/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState, useEffect, useRef } from 'react';
import history from '@history';
import {
	CircularProgress,
	Avatar,
	TextField,
	FormControl,
	InputLabel,
	Select,
	MenuItem,
	FormHelperText,
	Button,
	Table,
	TableHead,
	TableBody,
	TableCell,
	TableContainer,
	TableRow,
	Paper,
} from '@material-ui/core';
import {
	getCompany,
	getStateListByCountry,
	getCountryList,
	getCityList,
	getCompSchoolList,
} from 'app/services/Company/companyService';
import FuseScrollbars from '@fuse/core/FuseScrollbars';
import * as Actions from 'app/store/actions';
import FuseAnimate from '@fuse/core/FuseAnimate';
import CustomButton from 'app/customComponents/CustomButton/CustomButton';
import { useDispatch } from 'react-redux';
import './Company.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/free-solid-svg-icons';
import { useParams } from 'react-router-dom';
import CustomCheckbox from 'app/customComponents/CustomCheckbox/CustomCheckbox';
import InfiniteScroll from 'react-infinite-scroll-component';
import { makeStyles } from '@material-ui/core/styles';
import DisableSchooConfirmDialog from './DisableSchooConfirmDialog';
import { exportSchoolData } from 'app/services/reports/reports';
import StyledInput from 'shared/components/StyledInput';
import PageHeader from 'shared/components/PageHeader/PageHeader';
import GradientButton from 'shared/components/GradientButton';

const useStyles = makeStyles(() => ({
	wrapper: {
		display: 'flex',
		position: 'fixed',
		width: '100%',
		height: '100%',
		flex: '1 1 auto',
	},
}));
const ViewCompany = () => {
	const classes = useStyles();
	const dispatch = useDispatch();
	const [form, setForm] = useState({ status: 1 });
	const [isLoading, setIsLoading] = useState(true);
	const [countries, setCountries] = useState([]);
	const [states, setStates] = useState([]);
	const { id } = useParams();
	const [preview, setPreview] = useState(null);
	const [rows, setRows] = useState([]);
	const [firstLoad, setFirstLoad] = useState(true);
	const [refresh, setRefresh] = useState(false);
	const [page, setPage] = useState(1);
	const [hasMore, setHasMore] = useState(false);
	const [fetchingMore, setFetchingMore] = useState(false);
	const [isSchoolLoading, setIsSchoolLoading] = useState(false);
	const [exportLoaders, setExportLoaders] = useState([]);

	useEffect(() => {
		let isMounted = true;
		setIsLoading(true);
		getCompany(id)
			.then((res) => {
				if (!isMounted) return;
				setForm(res.data);
				setIsLoading(false);
			})
			.catch(() => {
				if (!isMounted) return;
				dispatch(
					Actions.showMessage({
						message: 'Failed to get company details.',
						autoHideDuration: 1500,
						variant: 'error',
					})
				);
				setIsLoading(false);
			});
		return () => {
			isMounted = false;
		};
	}, [id]);

	useEffect(() => {
		let isMounted = true;
		const timeout = setTimeout(
			() => {
				if (!isMounted) return;
				setIsSchoolLoading(true);
				getCompSchoolList(id, 1)
					.then((res) => {
						if (!isMounted) return;
						setFirstLoad(false);
						setRows(res.data.data || []);
						setExportLoaders(res.data.data.map(() => false));
						setHasMore(res.data.to < res.data.total);
						setPage(res.data.current_page + 1);
					})
					.catch(() => {
						if (!isMounted) return;
						dispatch(
							Actions.showMessage({
								message: 'Failed to fetch data, please refresh',
								variant: 'error',
							})
						);
					})
					.finally(() => {
						if (!isMounted) return;
						setIsSchoolLoading(false);
					});
			},
			firstLoad ? 0 : 1000
		);
		return () => {
			isMounted = false;
			clearTimeout(timeout);
		};
		// eslint-disable-next-line
	}, [refresh]);

	const handleLoadMore = () => {
		setFetchingMore(true);
		getCompSchoolList(id, page)
			.then((res) => {
				if (res.data.last_page > res.data.current_page) {
					setHasMore(true);
				} else {
					setHasMore(false);
				}
				setPage(res.data.current_page + 1);
				setRows(rows.concat(res.data.data));
				setExportLoaders(exportLoaders.concat(res.data.data.map(() => false)));
				setFetchingMore(false);
			})
			.catch(() => {
				setFetchingMore(false);
				dispatch(
					Actions.showMessage({
						message: 'Failed to fetch data, please refresh',
						variant: 'error',
					})
				);
			});
	};

	useEffect(() => {
		setPreview(form?.logo || null);
	}, [form?.logo]);

	const handleDisable = (ev, row) => {
		ev.preventDefault();
		dispatch(
			Actions.openDialog({
				children: <DisableSchooConfirmDialog refresh={refresh} row={row} setRefresh={setRefresh} />,
			})
		);
	};

	useEffect(() => {
		let isMounted = true;
		if (form.country_code) {
			getStateListByCountry(form.country_code)
				.then((res) => {
					if (!isMounted) return;
					setStates(res.data);
				})
				.catch(() => {
					if (!isMounted) return;
					dispatch(
						Actions.showMessage({
							message: 'Failed to get states.',
							autoHideDuration: 1500,
							variant: 'error',
						})
					);
				});
		}
		return () => {
			isMounted = false;
		};
	}, [form.country_code]);

	useEffect(() => {
		let isMounted = true;
		getCountryList()
			.then((res) => {
				if (!isMounted) return;
				setCountries(res.data);
			})
			.catch(() => {
				if (!isMounted) return;
				dispatch(
					Actions.showMessage({
						message: 'Failed to get countries.',
						autoHideDuration: 1500,
						variant: 'error',
					})
				);
			});
		return () => {
			isMounted = false;
		};
	}, []);

	const exportCompany = (school, index) => {
		setExportLoaders(exportLoaders.map((item, i) => (i === index ? true : item)));
		exportSchoolData(school.id)
			.then((res) => {
				const link = document.createElement('a');
				link.href = res.data.downloadable_file;
				link.setAttribute('download', `${school.name}-data-export.zip`);
				document.body.appendChild(link);
				link.click();
				link.parentNode.removeChild(link);
			})
			.catch(() => {
				dispatch(
					Actions.showMessage({
						message: 'Failed to export school data.',
						variant: 'error',
					})
				);
			})
			.finally(() => {
				setExportLoaders(exportLoaders.map((item, i) => (i === index ? false : item)));
			});
	};

	const goBack = () => {
		history.push({
			pathname: '/Company',
		});
	};

	const gotoEdit = (row) => {
		history.push({
			pathname: `/SchoolDetail/${row.id}`,
			state: {
				row,
			},
		});
	};

	const companyOwner = form?.admins?.find((admin) => admin.pivot.primary);

	return (
		<FuseAnimate animation="transition.slideLeftIn" duration={600}>
			<FuseScrollbars className={classes.content} scrollToTopOnRouteChange>
				<div className="mb-[162px] mx-60">
					<div className="flex justify-between items-end my-[40px]">
						<PageHeader onBack={goBack} title="Company Details" />
						<div className="flex" style={{ marginRight: 15 }}>
							<span className="mx-4">
								<GradientButton
									onClick={() => history.push({ pathname: `/EditCompany/${id}` })}
									variant="tertiary"
									width=""
									size="small"
								>
									<FontAwesomeIcon icon={faEdit} />
									<span> Edit </span>
								</GradientButton>
							</span>
						</div>
					</div>

					<div className="bg-white rounded-3xl p-60 shadow-md">
						{isLoading ? (
							<div className="flex justify-center items-center min-h-[400px]">
								<CircularProgress />
							</div>
						) : (
							<>
								<div className="font-bold mb-32">
									<h1 className="text-[18px]">Company Information</h1>
								</div>
								<div className="mt-32 flex flex-col md:flex-row gap-32 md:gap-60 items-start">
									<div className="mx-auto md:mx-0">
										<Avatar className="w-[120px] h-[120px]" src={preview} />
									</div>

									<div className="flex flex-col gap-36 w-full mt-32">
										<div
											className="grid gap-40 gap-y-60"
											style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))' }}
										>
											<StyledInput disabled label="Name of Company" value={form?.name || ''} />
											<StyledInput
												disabled
												label="Owner Email Address"
												value={companyOwner?.email || ''}
											/>
											<StyledInput
												disabled
												label="Owner First Name"
												value={companyOwner?.first_name || ''}
											/>
											<StyledInput
												disabled
												label="Owner Last Name"
												value={companyOwner?.last_name || ''}
											/>

											<StyledInput
												disabled
												label="Owner Contact Number"
												value={companyOwner?.phone || ''}
											/>

											<StyledInput
												disabled
												label="Total No of Schools"
												value={form?.branches_count || ''}
											/>

											<StyledInput
												disabled
												label="Total Active Subscribers"
												value={form?.total_subscribers || ''}
											/>

											<StyledInput disabled label="Address" value={form?.address || ''} />

											<StyledInput
												disabled
												label="Country"
												value={countries.find((c) => c.code === form.country_code)?.name || ''}
											/>

											<StyledInput
												disabled
												label="State"
												value={states.find((s) => s.id === form.state_id)?.name || ''}
											/>

											<StyledInput disabled label="City" value={form?.city || ''} />

											<StyledInput disabled label="Zipcode" value={form?.zip_code || ''} />

											<StyledInput
												disabled
												label="Status"
												value={form?.status === 1 ? 'Active' : 'Inactive'}
											/>
										</div>
									</div>
								</div>

								<div className="flex  justify-between school-listing-div">
									<div className="flex gap-10">
										<h2 className="font-bold" style={{ fontSize: '20px' }}>
											Schools
										</h2>
									</div>
									<div className="flex">
										<span className="mx-4">
											<GradientButton
												onClick={() => history.push({ pathname: `/addSchool/${id}` })}
												size="small"
												variant="tertiary"
											>
												+ Add
											</GradientButton>
										</span>
									</div>
								</div>
								<TableContainer
									className="company-school-table"
									component={Paper}
									id="Scrollable-table"
								>
									<Table className="company-table" stickyHeader>
										<TableHead>
											<TableRow>
												<TableCell
													className="bg-white companyTableHeader"
													style={{ width: '19%' }}
												>
													School Name
												</TableCell>
												<TableCell
													className="bg-white companyTableHeader"
													style={{ width: '15%' }}
												>
													Active Subscribers
												</TableCell>
												<TableCell
													className="bg-white companyTableHeader"
													style={{ width: '15%' }}
												>
													Email Address
												</TableCell>
												<TableCell
													className="bg-white companyTableHeader"
													style={{ width: '10%' }}
												>
													Contact No.
												</TableCell>
												<TableCell
													className="bg-white companyTableHeader"
													style={{ width: '10%' }}
												>
													Status
												</TableCell>
												<TableCell
													className="bg-white companyTableHeader"
													style={{ width: '20%' }}
												>
													Action
												</TableCell>
											</TableRow>
										</TableHead>
										<TableBody className="">
											{isSchoolLoading ? (
												<TableRow>
													<TableCell align="center" colSpan={8}>
														<CircularProgress />
													</TableCell>
												</TableRow>
											) : !rows.length && !firstLoad ? (
												<TableRow>
													<TableCell align="center" colSpan={8}>
														No Schools
													</TableCell>
												</TableRow>
											) : (
												rows?.map((row, index) => (
													<TableRow key={row.id}>
														<TableCell
															component="th"
															scope="row"
															style={{ fontWeight: 700 }}
														>
															<div className="flex items-center">
																<Avatar
																	alt="company-face"
																	className="mr-6"
																	src={row?.logo}
																/>
																<div style={{ fontSize: 12 }}>{row?.name}</div>
															</div>
														</TableCell>
														<TableCell align="left">
															<div style={{ fontSize: 12 }}>{row?.total_subscribers}</div>
														</TableCell>
														<TableCell align="left">
															<div style={{ fontSize: 12 }}>{row?.email}</div>
														</TableCell>
														<TableCell align="left">
															<div style={{ fontSize: 12 }}>{row?.phone}</div>
														</TableCell>
														<TableCell>
															<div
																style={{
																	fontWeight: 'bold',
																	fontSize: 12,
																	color: `${row?.status === 1 ? '#04C01C' : '#FF4B4B'}`,
																}}
															>
																{row?.status === 1 ? 'Active' : 'Inactive'}
															</div>
														</TableCell>
														<TableCell className="action-cell">
															<span
																className="view-btn-wrapper"
																id={`view-details-${index}`}
																onClick={() => {
																	gotoEdit(row);
																}}
															>
																<button style={{ fontSize: 11 }} type="button">
																	View Details
																</button>
															</span>
															{exportLoaders[index] ? (
																<CircularProgress size={20} />
															) : (
																<img
																	alt="export"
																	className="cursor-pointer"
																	onClick={() => exportCompany(row, index)}
																	src="assets/images/export.svg"
																	width="30px"
																/>
															)}
															<CustomCheckbox
																id={index}
																onClick={handleDisable}
																row={row}
															/>
														</TableCell>
													</TableRow>
												))
											)}
											{fetchingMore ? (
												<TableRow>
													<TableCell align="center" colSpan={8}>
														<CircularProgress />
													</TableCell>
												</TableRow>
											) : (
												<></>
											)}
										</TableBody>
									</Table>
								</TableContainer>
								<InfiniteScroll
									dataLength={rows.length}
									hasMore={hasMore}
									next={handleLoadMore}
									scrollableTarget="Scrollable-table"
								/>
							</>
						)}
					</div>
				</div>
			</FuseScrollbars>
		</FuseAnimate>
	);
};

export default ViewCompany;
